module.exports = __webpack_public_path__ + "img/saint-nicholas-day.2f8015ee.webp";